// let faqPage = document.getElementById('faq-page');
let dynamicFAQs = document.querySelectorAll('.dynamic-faq-block');
// let faqWrapper = document.createElement('div');
// faqWrapper.id = 'faq-listing';
let faqWrapper = ``;
dynamicFAQs.forEach(child => {
    //faqWrapper.appendChild(child);
    faqWrapper += child.innerHTML;
});

// faqPage.appendChild(faqWrapper);
const questionsParentDiv = document.querySelector('[data-questionsParent]');
let faqWrapperDiv = faqWrapper;
if(questionsParentDiv && faqWrapperDiv) questionsParentDiv.innerHTML = `<div id="faq-listing"> ${faqWrapperDiv}</div>`;
window.onload = () => {
    document.querySelectorAll('.dynamic-faq-block').forEach((dynamic_faq_block)=>{
        dynamic_faq_block.remove();
    });
};
// const questionsParent = document.querySelector('[data-questionsParent]');
// questionsParent.appendChild(faqWrapper);

function faqSelected(currentTarget) {
    var faqTitleLIst = currentTarget.closest('[data-faq]');
    var allElements = faqTitleLIst.querySelectorAll("li");

    allElements.forEach(element => {
        if (element.querySelector("a").classList.contains('active')) {
            element.querySelector("a").classList.remove("active");
        }
    });
    currentTarget.classList.add('active');
}
class faqpageScroll {
    constructor() { 
        this.flag=true;
        this.faqlist=document.querySelectorAll('.faq-listing a');
        this.faqlist.forEach(button => button.addEventListener('click', this.mangeScroll.bind(this)));
        this.faqsDIV=document.querySelectorAll('[data-faq-section-parent]');
        document.addEventListener('scroll', this.windowscroll.bind(this));
    }

    // click event 
    mangeScroll(event){
        event.preventDefault();
        this.flag=false;
        let currentTarget = event.currentTarget;
        let targetDivID= currentTarget.getAttribute("div-id");
        let targetDiv=document.querySelector(`#${targetDivID}`);

        if(targetDiv){
            let headerHeight = document.querySelector('header').clientHeight;
            let elementPosition = targetDiv.getBoundingClientRect().top;
            let offsetPosition = elementPosition + window.pageYOffset - headerHeight;
            window.scrollBy(0, elementPosition - headerHeight);
        }
        setTimeout(() => {
            this.flag=true;
          },500);
    }

    windowscroll(element){
        if(this.flag) {
            const divsInViewport = [];
            // Iterate over div elements and check if they are in viewport
            this.faqsDIV.forEach((div) => {
                if (this.isElementInViewport(div)) {
                        divsInViewport.push(div);
                }
            });
            if (divsInViewport[0]){
                let inViewportDivID= divsInViewport[0].closest('.section-faq').getAttribute("id");
                let faqNavs=document.querySelector(`[div-id=${inViewportDivID}]`);
                if (faqNavs.classList.contains('active')){
        
                }
                else{
                    let allElements = document.querySelectorAll("[div-id]");
                    allElements.forEach(element => {
                        if (element.classList.contains('active')) {
                            element.classList.remove("active");
                        }
                    });
                    faqNavs.classList.add('active');
                }
            }
        
            // this.faqsDIV.forEach((div) => {
            //     if (this.isElementInViewport(div)) {
            //         let inViewportDivID=div.closest('.section-faq').getAttribute("id");
            //         // console.log(inViewportDivID);
            //         let faqNavs=document.querySelector(`[div-id=${inViewportDivID}] a`);
            //         if (faqNavs.classList.contains('active')){
    
            //         }
            //         else{
            //             let allElements = document.querySelectorAll("[div-id]");
            //             allElements.forEach(element => {
            //                 if (element.querySelector("a").classList.contains('active')) {
            //                     element.querySelector("a").classList.remove("active");
            //                 }
            //             });
            //             faqNavs.classList.add('active');
            //         }
                
            //     }
            // });
    
            // Perform actions with the divsInViewport array
        }
    }
    isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }
}


typeof faqpageScroll !== 'undefined' && new faqpageScroll();




